export default __webpack_public_path__ + "static/media/company6.2ffe224e.png";